import React from "react";
import { Link } from "react-router-dom";
import { ABOUT, IMAGES } from "../../data";
import { Reveal, Eyebrow, H2 } from "./Typo";

export default function AboutBlock({ hideMore = false }) {
  return (
    <section id="about" data-testid="about-section" className="section-pad bg-[#F4F1E9]">
      <div className="container-hw grid lg:grid-cols-12 gap-12 lg:gap-10 items-start">
        <Reveal className="lg:col-span-5 relative">
          <img src={IMAGES.familyPhoto} alt="Max, founder of Honest Water LLC, with his family in Manassas, Virginia" loading="lazy" className="w-full aspect-[4/5] object-cover" />
          <img src={IMAGES.maxPortrait} alt="Max, founder of Honest Water LLC" loading="lazy"
            className="absolute -bottom-10 -right-4 md:-right-10 w-32 md:w-44 aspect-[3/4] object-cover border-[6px] border-[#F4F1E9]" />
        </Reveal>
        <Reveal delay={0.1} className="lg:col-span-6 lg:col-start-7 pt-10 lg:pt-6">
          <Eyebrow>{ABOUT.eyebrow}</Eyebrow>
          <H2 className="mt-6">{ABOUT.heading}</H2>
          <div className="mt-8 space-y-5 text-[1.03rem] leading-[1.8] text-[#3E474B] max-w-xl">
            {ABOUT.body.map((p) => <p key={p.slice(0, 20)}>{p}</p>)}
          </div>
          <div className="mt-10 pt-8 border-t border-[#D9D6CC] flex flex-wrap items-center justify-between gap-6 max-w-xl">
            <p className="font-heading italic text-2xl text-[#172B38]">{ABOUT.signature}</p>
            {!hideMore && <Link to="/about" data-testid="about-more" className="text-[0.92rem] text-[#172B38] border-b border-[#172B38] pb-0.5">More about us</Link>}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
